import * as Schemas from "../../forms/validationSchemas.js";

export function CIDRPanelValidationSchema(messages) {
  return Schemas.dropdownSchema("CIDR Class", messages, true);
}
